import React from "react";
import Infographics1 from "../../../../Assets/Images/participateflow/Infographics1.svg";
import Step1 from "../../../../Assets/Images/participateflow/Step1.svg";
import Step2 from "../../../../Assets/Images/participateflow/Step2.svg";
import Step3 from "../../../../Assets/Images/participateflow/Step3.svg";
import Step4 from "../../../../Assets/Images/participateflow/Step4.svg";
import Step5 from "../../../../Assets/Images/participateflow/Step5.svg";
import Step6 from "../../../../Assets/Images/participateflow/Step6.svg";
import pencil_infographics from "../../../../Assets/Images/participateflow/pencil_infographics.png";
import Infographics2 from "../../../../Assets/Images/participateflow/Infographics2.svg";
import { WEB_URL } from "../../../../redux/actions/config";
import "./../ChildHelps/style.css";

const ParticipateFlow = ({ eventCode }) => {
  return (
    <div className="narcworks">
      <div className="sectionBlock">
        <div className="leftSection">
          <div className="infographic"><img src={Infographics1} alt="Infographics1" /></div>
          <div className="block">
            <div className="img"><img src={Step1} alt="Step 1" /></div>
            <div className="text">
              Step 1 <br />
              <br /> Register the child
              <br /> by clicking{" "}
              <a href={`${WEB_URL}/champions/${eventCode}/register/individual`} target="_blank">here</a>
            </div>
          </div>
          <div className="block">
            <div className="img"><img src={Step2} alt="Step 2" /></div>
            <div className="text">
              Step 2 <br />
              <br /> Access age wise activities for child development
            </div>
          </div>
          <div className="block">
            <div className="img"><img src={Step3} alt="Step 3" /></div>
            <div className="text">
              Step 3 <br />
              <br /> Learn the activities through video tutorials and manuals
            </div>
          </div>
        </div>
        <div className="middleSection">
          <div className="img"><img src={pencil_infographics} alt="Pencil" /></div>
        </div>
        <div className="rightSection">
          <div className="infographic"><img src={Infographics2} alt="Infographics1" /></div>
          <div className="block">
            <div className="img"><img src={Step4} alt="Step 4" /></div>
            <div className="text">
              Step 4 <br />
              <br /> Record and upload submissions in any order
            </div>
          </div>
          <div className="block">
            <div className="img"><img src={Step5} alt="Step 5" /></div>
            <div className="text">
              Step 5 <br />
              <br /> Weekly receive ratings and personalized scorecard
            </div>
          </div>
          <div className="block">
            <div className="img"><img src={Step6} alt="Step 6" /></div>
            <div className="text">
              Step 6 <br />
              <br />
              Unlock online certificates and feature on multiple leaderboards
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipateFlow;
